__turbopack_context__.v({
  "fundraiserimage": "Ttaq3W_fundraiserimage",
  "header": "Ttaq3W_header",
  "headerimage": "Ttaq3W_headerimage",
});
